var CurrentUser = require("lib/account/CurrentUser");

class OnboardingStageSelectFeatures extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			selectedFeatures: [], orderedFeatureKeys: _.shuffle(FEATURE_OPTIONS)
		};
	}

	toggleFeature(featureKey) {
		var newFeatures = this.state.selectedFeatures;
		if (_.includes(newFeatures, featureKey)) {
			newFeatures = _.without(newFeatures, featureKey);
		} else {
			newFeatures.push(featureKey);
		}

		this.setState({ selectedFeatures: newFeatures });
	}

	submitFeatures() {
		var adminID = CurrentUser.get().id;
		var featuresData = { feature_overrides: this.state.selectedFeatures.join(",") }
		var params = { admin: featuresData };
		CurrentUser.api().patchAdmin(adminID, params, $wr.apiHandler((response) => {
			CurrentUser.fetchCurrentUserData();
		}));
		this.props.onComplete(featuresData);
		Mycroft.newEvent({ category: "Onboarding", action: "features-selected" });
	}

	featureDescription(featureKey) {
		if (featureKey == BOOK_REVIEWS) {
			return "Share book reviews";
		} else if (featureKey == CRITICAL_THINKING) {
			return "Practice critical thinking";
		} else if (featureKey == DAILY_READING) {
			return "Monitor daily reading";
		} else if (featureKey == TRACK_GOALS) {
			return "Track ELA goals";
		} else if (featureKey == WHO_READ) {
			return "Know who's reading";
		} else if (featureKey == WRITING_SKILLS) {
			return "Practice writing skills";
		}
	}

	renderFeatureOption(featureKey) {
		var featureImagePath = "onboarding/" + featureKey + ".png";

		var className = "largeObject clickableElement";
		if (_.includes(this.state.selectedFeatures, featureKey)) {
			className += " selectedFeature";
		}

		return (
			<div className={ className } key={ featureKey }
				onClick={ this.toggleFeature.bind(this, featureKey) }>
				<div className="featureObjectContent">
					<img src= { dynamicRequire(featureImagePath) } className="featureImg"/>
					<div className="featureDesc">
						{ this.featureDescription(featureKey) }
					</div>
				</div>
			</div>
		);
	}

	render() {
		var featureObjects = _.map(this.state.orderedFeatureKeys, (featureKey) => {
			return this.renderFeatureOption(featureKey);
		});
		var featureOptions = (
			<div className="featureOptions">
				{ featureObjects }
			</div>
		);

		var mainContent = (
			<div className="singleCol">
				<p className="onboardingGreeting">
					What would you like to do with Whooo's Reading?
				</p>
				<p className="onboardingInstructions">
					<span className="instructionTitle">This is just to get you started. You can always do more later.</span>
				</p>
			</div>
		);

		if (this.state.selectedFeatures.length > 0) {
			var submitButton = (
				<button className="btn buttonPrimary" onClick={ this.submitFeatures }>
					All Set
				</button>
			);
		}

		return (
			<div className="onboardingStage onboardingStageSelectFeatures clearfix">
				{ mainContent }
				{ featureOptions }
				{ submitButton }
			</div>
		);
	}
}

var BOOK_REVIEWS = "onboarding-book-reviews";
var CRITICAL_THINKING = "onboarding-critical-thinking";
var DAILY_READING = "onboarding-daily-reading";
var TRACK_GOALS = "onboarding-track-goals";
var WHO_READ = "onboarding-who-read";
var WRITING_SKILLS = "onboarding-writing-skills";

var FEATURE_OPTIONS = [
	BOOK_REVIEWS, CRITICAL_THINKING, DAILY_READING, TRACK_GOALS, WHO_READ, WRITING_SKILLS
];


OnboardingStageSelectFeatures.propTypes = StrictPropTypes({
	track: PropTypes.string.isRequired,
	onComplete: PropTypes.func.isRequired,
	// only used for the final stage of onboarding
	endOnboarding: PropTypes.func,
	persistentData: PropTypes.object
});

module.exports = OnboardingStageSelectFeatures;



// WEBPACK FOOTER //
// ./modules/components/users/teachers/onboarding/OnboardingStageSelectFeatures.js